module.exports = __webpack_public_path__ + "img/41_5.4c3c2933.png";